"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AccordionState_1 = require("./AccordionState");
var styles = require("./Accordion.scss");
var Accordion = /** @class */ (function (_super) {
    __extends(Accordion, _super);
    function Accordion(prop) {
        var _this = _super.call(this, prop) || this;
        _this.state = new AccordionState_1.default();
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handelOnKeyDown = _this.handelOnKeyDown.bind(_this);
        return _this;
    }
    Accordion.prototype.componentWillMount = function () {
        this.setState({
            class: styles.cartAccordion,
            open: !!(this.props.data && this.props.data.isSingleChild),
        });
    };
    Accordion.prototype.render = function () {
        return (React.createElement("div", { className: styles.cartAccordionContainer },
            this.props.data.isSingleChild ?
                (React.createElement("div", { className: styles.singleChild, tabIndex: 0 }, this.props.data.sectionTitle)) :
                (React.createElement("div", { tabIndex: 0, onKeyDown: this.handelOnKeyDown },
                    React.createElement("div", { className: this.state.class, onClick: this.handleClick }, this.props.data.sectionTitle))),
            this.state.open &&
                React.createElement("div", { className: this.props.data.isSingleChild ? ' ' : styles.cartAccordionOpenContent },
                    React.createElement("div", { className: [styles.alignLeft, this.props.data.isSingleChild ? ' ' : styles.cartAccordionContent].join(' ') },
                        this.props.data.sectionDescription && !this.props.data.isSingleChild &&
                            React.createElement("div", { className: styles.priceText }, this.props.data.sectionDescription),
                        this.props.data.sectionDescription && this.props.data.isSingleChild &&
                            React.createElement("div", { className: styles.singleChildDesc }, this.props.data.sectionDescription)))));
    };
    Accordion.prototype.handleClick = function () {
        if (this.state.open) {
            this.setState({
                class: styles.cartAccordion,
                open: false,
            });
        }
        else {
            this.setState({
                class: styles.cartAccordionclose,
                open: true,
            });
        }
    };
    Accordion.prototype.handelOnKeyDown = function (e) {
        if (e.keyCode === 13) {
            this.handleClick();
        }
    };
    return Accordion;
}(React.Component));
exports.default = Accordion;
//# sourceMappingURL=Accordion.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/Accordion/Accordion.js
// module id = 2334
// module chunks = 8